/*
 * CORK - bloque de entrega de la ficha (cork_delivery, en templates/product.json) segun el pais.
 * 30-09-2026. En Espana (ES) no toca nada: se queda el bloque original (24 h Peninsula, cuenta atras).
 * En el resto de paises reescribe el bloque con su plazo, su coste de envio y un rango de fechas
 * de llegada estimada, en el idioma de la pagina. Paises sin envio: oculta el bloque.
 * Plazos y costes = politica de envio / Sendcloud. Si cambian, actualizar COUNTRIES.
 * Disenos grabados: se suman 1-4 dias laborables de fabricacion antes del envio.
 * El pais lo pasa snippets/cork-shipping-notice.liquid en window.__corkGeo.
 */
(function () {
  if (window.__corkDeliveryGeo) return;
  window.__corkDeliveryGeo = true;

  var geo = window.__corkGeo || {};
  var country = (geo.country || 'ES').toUpperCase();
  if (country === 'ES') return;

  // [dias min, dias max (laborables, desde que sale), coste envio, gratis desde (null = nunca)]
  var Z1 = [7, 12, '9,99 €', '130 €'];
  var Z2 = [7, 12, '14,99 €', null];
  var COUNTRIES = {
    PT: [2, 5, '5,99 €', '50 €'],
    AD: [1, 2, '16,99 €', '130 €'],
    DE: Z1, BE: Z1, DK: Z1, FR: Z1, IE: Z1, IT: Z1, NL: Z1, PL: Z1, SE: Z1,
    HR: Z2, FI: Z2, GR: Z2
  };
  var ENGRAVE_MIN = 1, ENGRAVE_MAX = 4, CUTOFF = 13 * 60;

  var T = {
    es: { today: 'Pídelo antes de las 13:00 y sale hoy. Llegada estimada: <b>{r}</b>', next: 'Llegada estimada: <b>{r}</b>', eng: 'Diseño grabado bajo pedido. Llegada estimada: <b>{r}</b>', ship: 'Envío {c}', free: ' · gratis desde {f}', tail: '. Plazo en días laborables, orientativo.', engTail: '. Cada diseño se graba a láser para ti.' },
    ca: { today: 'Demana-la abans de les 13:00 i surt avui. Arribada estimada: <b>{r}</b>', next: 'Arribada estimada: <b>{r}</b>', eng: 'Disseny gravat per encàrrec. Arribada estimada: <b>{r}</b>', ship: 'Enviament {c}', free: ' · gratis des de {f}', tail: '. Termini en dies laborables, orientatiu.', engTail: '. Cada disseny es grava amb làser per a tu.' },
    en: { today: 'Order before 13:00 and it ships today. Estimated arrival: <b>{r}</b>', next: 'Estimated arrival: <b>{r}</b>', eng: 'Engraved design made to order. Estimated arrival: <b>{r}</b>', ship: 'Shipping {c}', free: ' · free from {f}', tail: '. Working days, estimated.', engTail: '. Every design is laser-engraved for you.' },
    fr: { today: 'Commandez avant 13h00, expédition aujourd’hui. Arrivée estimée : <b>{r}</b>', next: 'Arrivée estimée : <b>{r}</b>', eng: 'Design gravé sur commande. Arrivée estimée : <b>{r}</b>', ship: 'Livraison {c}', free: ' · offerte dès {f}', tail: '. Jours ouvrables, délai indicatif.', engTail: '. Chaque design est gravé au laser pour vous.' },
    de: { today: 'Bis 13:00 Uhr bestellen, Versand noch heute. Voraussichtliche Ankunft: <b>{r}</b>', next: 'Voraussichtliche Ankunft: <b>{r}</b>', eng: 'Gravur auf Bestellung. Voraussichtliche Ankunft: <b>{r}</b>', ship: 'Versand {c}', free: ' · gratis ab {f}', tail: '. Werktage, unverbindlich.', engTail: '. Jedes Design wird für dich lasergraviert.' },
    it: { today: 'Ordina entro le 13:00 e parte oggi. Arrivo stimato: <b>{r}</b>', next: 'Arrivo stimato: <b>{r}</b>', eng: 'Design inciso su ordinazione. Arrivo stimato: <b>{r}</b>', ship: 'Spedizione {c}', free: ' · gratis da {f}', tail: '. Giorni lavorativi, tempi indicativi.', engTail: '. Ogni design viene inciso al laser per te.' },
    pt: { today: 'Encomenda antes das 13:00 e sai hoje. Chegada estimada: <b>{r}</b>', next: 'Chegada estimada: <b>{r}</b>', eng: 'Design gravado por encomenda. Chegada estimada: <b>{r}</b>', ship: 'Envio {c}', free: ' · grátis a partir de {f}', tail: '. Dias úteis, prazo indicativo.', engTail: '. Cada design é gravado a laser para ti.' }
  };

  var DAY = 864e5;
  var lang = (document.documentElement.lang || 'es').toLowerCase();
  var L = T[lang.slice(0, 2)] || T.es;

  function madridNow() {
    try {
      var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hour: '2-digit', minute: '2-digit', hour12: false, weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
      var p = {};
      f.formatToParts(new Date()).forEach(function (x) { if (x.type !== 'literal') p[x.type] = x.value; });
      return { min: ((+p.hour) % 24) * 60 + (+p.minute), base: Date.UTC(+p.year, (+p.month) - 1, +p.day), wd: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(p.weekday) };
    } catch (e) {
      var d = new Date();
      return { min: d.getHours() * 60 + d.getMinutes(), base: Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()), wd: d.getDay() };
    }
  }
  function isBiz(ts) { var w = new Date(ts).getUTCDay(); return w >= 1 && w <= 5; }
  function addBiz(ts, n) { var t = ts; while (n > 0) { t += DAY; if (isBiz(t)) n--; } return t; }
  function nextBiz(ts) { var t = ts + DAY; while (!isBiz(t)) t += DAY; return t; }
  function fmt(ts) {
    try { return new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).format(new Date(ts)); }
    catch (e) { return new Date(ts).toISOString().slice(0, 10); }
  }

  function init() {
    var root = document.querySelector('[data-cpd]');
    if (!root) return;
    var cfg = COUNTRIES[country];
    if (!cfg) { root.style.display = 'none'; return; }
    var mainEl = root.querySelector('[data-cpd-main]');
    var subEl = root.querySelector('[data-cpd-sub]');
    if (!mainEl || !subEl) return;
    var dmap = {};
    try { dmap = JSON.parse(root.querySelector('[data-cpd-design]').textContent); } catch (e) {}
    var pc = root.closest('[data-js-product-component]');
    var picker = pc && pc.querySelector('product-variants[data-main-product-variants]');
    var lastMain = null, lastSub = null, obs = null;

    function apply() {
      var v = picker && picker.currentVariant;
      var vid = v && v.id ? String(v.id) : null;
      var engraved = vid ? dmap[vid] === 1 : false;
      var n = madridNow();
      var shipToday = n.wd >= 1 && n.wd <= 5 && n.min < CUTOFF;
      var shipTs = shipToday ? n.base : nextBiz(n.base);
      var minD = cfg[0], maxD = cfg[1];
      if (engraved) { shipTs = addBiz(shipTs, ENGRAVE_MIN); minD = cfg[0]; maxD = cfg[1] + (ENGRAVE_MAX - ENGRAVE_MIN); }
      var from = addBiz(shipTs, minD), to = addBiz(shipTs, maxD);
      var range = from === to ? fmt(from) : fmt(from) + ' \u2013 ' + fmt(to);
      var tpl = engraved ? L.eng : (shipToday ? L.today : L.next);
      var ship = L.ship.replace('{c}', cfg[2]) + (cfg[3] ? L.free.replace('{f}', cfg[3]) : '');
      lastMain = tpl.replace('{r}', range);
      lastSub = ship + (engraved ? L.engTail : L.tail);
      if (obs) obs.disconnect();
      mainEl.innerHTML = lastMain;
      subEl.textContent = lastSub;
      if (obs) watch();
    }
    function watch() {
      obs.observe(mainEl, { childList: true, characterData: true, subtree: true });
      obs.observe(subEl, { childList: true, characterData: true, subtree: true });
    }
    obs = new MutationObserver(function () {
      if (mainEl.innerHTML !== lastMain || subEl.textContent !== lastSub) apply();
    });
    apply();
    if (picker) picker.addEventListener('VARIANT_CHANGE', function () { window.requestAnimationFrame(apply); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
